import createAxiosInstance from './createAxiosInstance'

const mvcPath = process.env.VUE_APP_MVC_URL
const mvcInstance = createAxiosInstance(mvcPath)
const loginAPIConfig = {
  metadata: {
    userHandlesErrors: true,
    isApiNoNeedToLoginCommunity: true
  }
}


export const apiMvc = {
  getBottomRightNews: () => mvcInstance.get('/System/GetSystemNotificationList'), // 取得右下角提示窗之資料
  checkAccountPassword: (data) => mvcInstance.post('/Login/CheckAccountPassword', data, loginAPIConfig), // 檢查帳號密碼
  getCommunitysWithToken: (data) => mvcInstance.post('/Login/GetCommunitysWithToken', data, loginAPIConfig) // 取得社區列表
}
